module.exports = __webpack_public_path__ + "static/media/Marker-open.2a71d714.svg";